module.exports = __webpack_public_path__ + "static/media/head-icon-border_1px.a2a0d25b.svg";